import { useState } from 'react'
import eye from '../../assets/icons/eyeBlack.svg'
import { AnimatePresence } from 'framer-motion'
import ViewOrderReport from './ViewOrderReport'

const ReportRow = ({ row, index }) => {
  const [view, setView] = useState(false)
  function formatDate(dateString) {
    const options = { year: '2-digit', month: '2-digit', day: '2-digit' }
    const date = new Date(dateString)
    return date.toLocaleDateString('en-GB', options)
  }

  return (
    <>
      <div className={`${index % 2 === 0 ? '' : ' bg-gray/20'} flex`}>
        <div className="flex-1 p-2 items-center justify-center flex">
          {row.order_id}
        </div>
        <div className="flex-1 p-2 items-center justify-center flex">
          {row.client_name}
        </div>
        <div className="flex-1 p-2 items-center justify-center flex">
          {row.total_sum ? parseFloat(row.total_sum).toFixed(2) : 'no price'}
        </div>
        <div className="flex-1 p-2 items-center text-center justify-center flex">
          {row.status}
        </div>
        <div className="flex-1 p-2 items-center justify-center flex">
          {formatDate(row.created_at)}
        </div>
        <div className="flex-1 p-2 items-center justify-center flex">
          <button
            onClick={() => setView(true)}
            className="w-6 h-6 aspect-square flex text-blueButton rounded hover:bg-blue-600"
          >
            <span>
              <img src={eye} alt="" />
            </span>
          </button>
        </div>
      </div>

      <AnimatePresence>
        {view && (
          <ViewOrderReport
            orderReport={row}
            active={view}
            close={() => setView(false)}
          />
        )}
      </AnimatePresence>
    </>
  )
}

export default ReportRow
